// extracted by mini-css-extract-plugin
export var imageSelectFooter = "image-select__footer_N0AedXOCEyRzp8LUoE3Y";
export var imageSelectPlaceholder = "image-select__placeholder_S3kmDwmVrq2w3T4DHkZt";
export var imageSelectPreview = "image-select__preview__0ezxOf4w0RUsrdIi2DP";
export var imageSelectPreviewContainer = "image-select__preview-container_ZtQ6To7eJCgY0nsG6e_W";
export var imageSelectServiceIcon = "image-select__service-icon_oUn4Vtr2fQXzSdZQHYrF";